import { ArrowRight } from "lucide-react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { canRemindKyc } from "../misc/kyc";
import { publisherDetailsPath, publisherDetailsState } from "../misc/constants";

// The trailing actions of a publisher row, identical in both lists. `children` slots
// in anything list-specific (the brand tab's Pay button) ahead of them. The row itself
// opens the publisher, so clicks here must not bubble into it.
const KycRowActions = ({ publisher, kyc, from, children }) => (
    <div className="flex items-center justify-end gap-2" onClick={(e) => e.stopPropagation()}>
        {children}
        {canRemindKyc(publisher) && kyc.canSendFor(publisher) && (
            <button
                type="button"
                onClick={() => kyc.openReminder(publisher)}
                className="px-1 text-xs font-medium text-accent hover:underline">
                Remind
            </button>
        )}
        <Link
            to={publisherDetailsPath(publisher._id)}
            state={publisherDetailsState(publisher, from)}
            className="inline-flex items-center gap-1 text-sm font-medium text-accent hover:underline">
            Open
            <ArrowRight className="h-3.5 w-3.5" />
        </Link>
    </div>
);

KycRowActions.propTypes = {
    publisher: PropTypes.object.isRequired,
    kyc      : PropTypes.object.isRequired,
    from     : PropTypes.object,
    children : PropTypes.node
};

export default KycRowActions;
